import { z } from "zod";

/**
 * Base Migration Schema (raw database record)
 *
 * Matches _prisma_migrations table structure.
 * Note: No `success` column - use finished_at + rolled_back_at to determine status.
 */
export const MigrationSchema = z.object({
  id: z.string(),
  checksum: z.string(),
  finished_at: z.coerce.date().nullable(),
  migration_name: z.string(),
  logs: z.string().nullable(),
  started_at: z.coerce.date(),
  rolled_back_at: z.coerce.date().nullable(),
  applied_steps_count: z.number()
});

export const MigrationStatusSchema = z.enum(["applied", "pending", "failed", "resolved"]);

export const MigrationWithStatusSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: MigrationStatusSchema,
  finishedAt: z.coerce.date().nullable(),
  startedAt: z.coerce.date(),
  executionTime: z.number().nullable(),
  logs: z.string().nullable(),
  // Resolution tracking (only for failed migrations)
  resolvedAt: z.coerce.date().nullable().optional(),
  resolvedBy: z.string().nullable().optional(),
  resolutionNote: z.string().nullable().optional()
});

export const ListMigrationsResponseSchema = z.object({
  migrations: z.array(MigrationWithStatusSchema),
  stats: z.object({
    total: z.number(),
    applied: z.number(),
    pending: z.number(),
    failed: z.number(),
    resolved: z.number()
  })
});

export const DeployMigrationsBodySchema = z.object({
  dryRun: z.boolean().default(false)
});

export const DeployMigrationsResponseSchema = z.object({
  success: z.boolean(),
  deployed: z.array(z.string()), // Migration names
  skipped: z.array(z.string()),
  errors: z.array(z.string()).optional()
});

export const GetMigrationSqlResponseSchema = z.object({
  migrationName: z.string(),
  sql: z.string()
});

export const MarkResolvedBodySchema = z.object({
  resolutionNote: z.string().optional()
});

export const MarkResolvedResponseSchema = z.object({
  success: z.boolean(),
  migrationName: z.string(),
  resolvedAt: z.coerce.date(),
  resolvedBy: z.string()
});
